import { useAtom } from "jotai";
import { useLogin } from "../login";
import { 
    WallmatesAnalytics, 
    analyticsAtom,
} from "./types";
import { environment } from "../../environment";
import axios from "axios";
import { errorCatcher, useSnackbar } from "../../hooks";


type GetAverageFulfillmentTime = (startDate: string, endDate: string, brandId?: number, designId?: number) => Promise<WallmatesAnalytics | void>;

type UseAnalyticsKeyFunctions = {
    getAverageFulfillmentTime: GetAverageFulfillmentTime;
}

type UseAnalytics = [
    WallmatesAnalytics | null,
    UseAnalyticsKeyFunctions
]

export const useAnalytics = (): UseAnalytics => {
    const [, authToken, loginFunctions] = useLogin();
    const [, setSnackbar] = useSnackbar();
    const [analytics, setAnalytics] = useAtom(analyticsAtom);

    const getAverageFulfillmentTime = async (startDate: string, endDate: string, brandId?: number, designId?: number) => {
        const brandParam = brandId ? `&brandId=${brandId}` : '';
        const designParam = designId ? `&designId=${designId}` : '';
        const response = await axios.get(`${environment.v2Url}/analytics/average-fulfillment-time?startDate=${startDate}&endDate=${endDate}${brandParam}${designParam}`, {
            headers: {
                'X-Wallmates-Auth': authToken
            }
        }).catch((err: any) => errorCatcher(err, loginFunctions.logout));

        if (response) {
            setAnalytics(response.data);
            return response.data;
        } else {
            setSnackbar({
                show: true,
                snackbarLevel: 'error',
                text: 'There was an error getting the average fulfillment time'
            });
        }
    }

    return [
        analytics,
        {
            getAverageFulfillmentTime,
        }
    ];
}
